export default __webpack_public_path__ + "locales/es/InviteDialog.json?hash=c8d70c2d05d8b19de0d42d301b863f45";